import { PluginKey } from 'prosemirror-state';
import type { Transaction } from 'prosemirror-state';

import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { NextEditorPlugin, OptionalPlugin } from '@atlaskit/editor-common/types';
import type { AnalyticsPlugin } from '@atlaskit/editor-plugin-analytics';

import { getEventHandlersForLiveSearchExtension } from './getEventHandlersForLiveSearchExtension';

export const pluginName = 'extensionManager';
export const pluginKey = new PluginKey<ExtensionManagerPluginState>(pluginName);

type PageContext = {
	isLivePage?: boolean;
	spaceKey?: string;
	contentId?: string;
};

type AnchorMacroToolbarState = {
	showAnchorLinkCopiedTooltip?: boolean;
	pageContext?: PageContext;
};

type ExtensionManagerPluginState = AnchorMacroToolbarState | undefined;

export type ExtensionManagerPlugin = NextEditorPlugin<
	'extensionManager',
	{
		sharedState: ExtensionManagerPluginState;
		dependencies: [OptionalPlugin<AnalyticsPlugin>];
	}
>;

export const createPlugin = () =>
	new SafePlugin<ExtensionManagerPlugin>({
		key: pluginKey,
		state: {
			init: (): ExtensionManagerPluginState => ({}),
			apply(tr: Transaction, pluginState: ExtensionManagerPluginState) {
				const metadata = tr.getMeta(pluginKey);

				if (metadata) {
					return {
						...pluginState,
						...metadata,
					};
				}

				return pluginState;
			},
		},
		props: {
			handleDOMEvents: {
				...getEventHandlersForLiveSearchExtension(),
			},
		},
		// @TODO Use appendTransaction to gurantee unique anchor name macro param on paste action https://hello.jira.atlassian.cloud/browse/PGEXP-291
	});
